import officeApiIsRequirementSetSupported from './async/infrastructure/office-api-is-requirement-set-supported'
import graph from '../graph/graph-wrapper'

import {
  officeApiMailbox_DisplayDialogAsync,
  officeApiMailbox_DisplayMessageFormAsync,
  officeApiMailbox_DisplayNewMessageFormAsync,
} from './async/office-api-mailbox-async'

async function officeDisplayMessageForm(id: string) {
  let restId: string | null = null

  // Try Graph API first if available
  if (graph.isAvailable()) {
    try {
      const translatedIds = await graph.translateExchangeIds([id], 'restImmutableEntryId', 'restId')
      if (translatedIds && translatedIds.length > 0) {
        restId = translatedIds[0]
      }
    } catch (error) {
      // Fall back to Office API if Graph API fails
    }
  }

  // Fall back to Office API if Graph API is not available or failed
  if (!restId && Office.context.mailbox.convertToRestId) {
    restId = Office.context.mailbox.convertToRestId(id, Office.MailboxEnums.RestVersion.v2_0)
  }

  if (restId) {
    if (asyncFormsSupported()) {
      await officeApiMailbox_DisplayMessageFormAsync(restId)
    } else {
      Office.context.mailbox.displayMessageForm(restId)
    }
  } else {
    throw 'Missing Item Id'
  }
}

async function officeDisplayNewMessageForm(subject: string, email: string) {
  const newMessage = {
    subject: subject,
    toRecipients: [email],
  }

  if (asyncFormsSupported()) {
    await officeApiMailbox_DisplayNewMessageFormAsync(newMessage)
  } else if (Office.context.mailbox.displayNewMessageForm) {
    Office.context.mailbox.displayNewMessageForm(newMessage)
  } else {
    let mailto = 'mailto: ' + email
    if (subject) {
      mailto += '?subject=' + subject
    }
    window.location.href = mailto
  }
}

function asyncFormsSupported(): boolean {
  return officeApiIsRequirementSetSupported('1.9')
}

const exportFunctions = {
  openEmail: officeDisplayMessageForm,
  openCompose: officeDisplayNewMessageForm,
  displayDialog: officeApiMailbox_DisplayDialogAsync,
}

export default exportFunctions
